import { Reveal, Stagger, StaggerItem } from "@/components/anim/Reveal";
import CTASection from "@/components/site/CTASection";
import { INDUSTRIES } from "@/data/solutions";

const Industries = () => {
  return (
    <div data-testid="page-industries">
      <section className="relative pt-24 pb-8 md:pt-32">
        <div className="fs-grid-bg" />
        <div className="fs-container relative">
          <Reveal><div className="fs-eyebrow">Industries We Serve</div></Reveal>
          <Reveal delay={0.1}>
            <h1 className="fs-heading text-4xl md:text-6xl mt-5 max-w-4xl">
              Trusted across sectors that{" "}
              <span className="fs-gradient-text">can't afford downtime.</span>
            </h1>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-6 text-[color:var(--text-dim)] max-w-2xl leading-relaxed">
              From regulated finance to fast-moving retail, Four Square powers
              the mission-critical backbone of India's most demanding sectors.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="fs-section pt-8">
        <div className="fs-container">
          <Stagger className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4" stagger={0.06}>
            {INDUSTRIES.map((i) => {
              const Icon = i.icon;
              return (
                <StaggerItem key={i.name}>
                  <div className="fs-card p-6 h-full" data-testid={`industries-page-${i.name.replace(/[^a-z0-9]/gi, "-").toLowerCase()}`}>
                    <div className="fs-icon-tile"><Icon size={20} /></div>
                    <h3 className="mt-5 text-lg font-semibold">{i.name}</h3>
                    <p className="mt-2 text-sm text-[color:var(--text-dim)] leading-relaxed">
                      Reliable, secure and compliant enterprise infrastructure —
                      built for the operational realities of {i.name}.
                    </p>
                  </div>
                </StaggerItem>
              );
            })}
          </Stagger>
        </div>
      </section>

      <CTASection />
    </div>
  );
};

export default Industries;
